import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {
    UmRoleObjectComponent
} from "../component/protected-components/object/um-role-object-component/um-role-object.component";
import {UserCalendarComponent} from "../component/protected-components/user-calendar-component/user-calendar.component";
import {UserProfileComponent} from "../component/protected-components/user-profile/user-profile.component";
import {
    UmRoleObjectSideComponent
} from "../component/protected-components/object/um-role-object-component/view/um-role-object-side/um-role-object-side.component";
import {
    UmRoleObjectFullComponent
} from "../component/protected-components/object/um-role-object-component/view/um-role-object-full/um-role-object-full.component";
import {UserProfileIdComponent} from "../component/protected-components/user-profile-id/user-profile-id.component";
import {Provider} from "@angular/core";

const umModuleEntry: TestModuleDefinition = {
    key: 'um',
    label: 'User (um)',
    components: [
        {
            key: 'UmRoleObjectComponent',
            component: UmRoleObjectComponent,
            selector: 'um-role-object-component',
            label: 'UM Role Object',
            type: 'ObjectBaseComponent',
        },
        {
            key: 'UserCalendarComponent',
            component: UserCalendarComponent,
            selector: 'user-calendar',
            label: 'USER Calendar Component',
            type: 'Component',
        },
        {
            key: 'UserProfileComponent',
            component: UserProfileComponent,
            selector: 'user-profile',
            label: 'USER Profile Component',
            type: 'PageComponent',
        },
        {
            key: 'UserProfileIdComponent',
            component: UserProfileIdComponent,
            selector: 'user-profile-id',
            label: 'USER Profile Id',
            type: 'Component',
        },
        {
            key: 'UmRoleObjectSideComponent',
            component: UmRoleObjectSideComponent,
            selector: 'um-role-object-side',
            label: 'User Role Object Side',
            type: 'Component',
        },
        {
            key: 'UmRoleObjectFullComponent',
            component: UmRoleObjectFullComponent,
            selector: 'um-role-object-full',
            label: 'User Role Object Full',
            type: 'Component',
        }
    ]
}

export const UM_TEST_PROVIDERS: Provider[]= [
    {
        provide: TEST_MODULE_REGISTRY, useValue: umModuleEntry, multi: true
    }
]